import * as React from "react"
import { Container, Row } from "react-grid-system"
import { useLocation } from "react-router"
import H1 from "../atoms/typography/H1"
import { useMyOrganization } from "../../hooks/useMyOrganization"
import LoadingSpinner from "../atoms/LoadingSpinner"
import { HorizontalSpacer } from "../atoms/spacers"
import DataPlansPage from "./dashboard/DataPlansPage"
import TerminalsPage from "./dashboard/TerminalsPage"
import GroupsPage from "./dashboard/GroupsPage"
import AllSuborganizationsDropdown from "../molecules/AllSuborganizationsDropdown"
import * as Sentry from "@sentry/react"
import { getAllOrgIds } from "../../utils/helpers"

const DashboardPage: React.FunctionComponent = () => {
  const { myOrganization, orgLoading } = useMyOrganization()
  const location = useLocation()

  const isGroupsPage = location?.pathname?.includes("groups")

  const allSuborgIds: Array<number> = getAllOrgIds(myOrganization?.childOrganizations?.edges ?? [])

  React.useEffect(() => {
    document.title = "Dashboard"
  }, [])

  const [suborgFilter, setSuborgFilter] = React.useState<Array<number> | undefined>(
    isGroupsPage ? allSuborgIds : undefined,
  )

  React.useMemo(() => {
    isGroupsPage && setSuborgFilter(allSuborgIds)
  }, [myOrganization])

  const checkSuborgSelected = (id: number) => {
    return suborgFilter?.includes(id)
  }
  const onClickSuborg = (id?: number, checkedMain?: boolean) => {
    if (checkedMain) {
      isGroupsPage ? setSuborgFilter(allSuborgIds) : setSuborgFilter(undefined)
    } else if (!id) {
      Sentry.captureMessage("Error setting suborganization filter")
    } else {
      if (!suborgFilter) {
        setSuborgFilter([id])
      } else if (checkSuborgSelected(id)) {
        if (suborgFilter.length === 1) {
          setSuborgFilter(undefined)
        } else {
          setSuborgFilter(suborgFilter?.filter((x) => x !== id))
        }
      } else {
        setSuborgFilter([...suborgFilter, id])
      }
    }
  }
  const onDeselectAllSuborgs = () => {
    setSuborgFilter([])
  }

  return (
    <div>
      <Container>
        <HorizontalSpacer spacing={4} />
        <Row justify="center" style={{ padding: "0 15px" }}>
          <H1>{myOrganization?.name} Dashboard</H1>
        </Row>
        <AllSuborganizationsDropdown
          org={myOrganization}
          onClickSuborg={onClickSuborg}
          selected={suborgFilter}
          onDeselectAllSuborgs={onDeselectAllSuborgs}
        />
      </Container>
      {orgLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {location?.pathname?.includes("terminals") ? (
            <TerminalsPage suborgFilter={suborgFilter} />
          ) : isGroupsPage ? (
            <GroupsPage suborgFilter={suborgFilter} />
          ) : (
            <DataPlansPage suborgFilter={suborgFilter} />
          )}
        </>
      )}
      <HorizontalSpacer spacing={2} />
    </div>
  )
}

export default DashboardPage
